import React, { useState } from "react";
import InvoiceViewer from "./InvoiceViewer";
import { PDFViewer } from "./UploadPO";

const InvoicePDFViewer = ({ selectedInvoice, requestItemData }) => {
  const [viewInvoice, setViewInvoice] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        height: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* InvoiceViewer with dynamic width */}
      <div
        style={{
          flex: viewInvoice ? "0.5" : "1", // Shrinks when PDFViewer appears
          transition: "flex 0.5s ease-in-out", // Smooth expansion/collapse
          overflow: "hidden",
        }}
      >
        <InvoiceViewer
          selectedInvoice={selectedInvoice}
          requestItemData={requestItemData}
          viewInvoice={viewInvoice}
          setViewInvoice={setViewInvoice}
        />
      </div>

      {/* PDF Viewer with sliding animation */}
      <div
        style={{
          position: "absolute",
          right: viewInvoice ? "0" : "-100%", // Slide in/out
          top: 0,
          bottom: 0,
          width: "50%", // Adjust width as needed
          background: "#fff",
          boxShadow: viewInvoice ? "-4px 0px 10px rgba(0, 0, 0, 0.1)" : "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "right 0.5s ease-in-out",
        }}
      >
        {viewInvoice && (
          <PDFViewer url={selectedInvoice.url} title={selectedInvoice.name} />
        )}
      </div>
    </div>
  );
};

export default InvoicePDFViewer;
